import Badge from "../../components/Badge";
import Avatar from 'react-avatar';
import ActionButton from "./ActionButton";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {useState} from "react";
import {Link} from "react-router-dom";
import {DateTimeOptionsMediumShort} from "../../utils/DateTimeOptions";
import NoneValue from "../../components/NoneValue";
import CopyToClipBoard from "../../components/CopyToClipBoard";
import OrderDetailsModal from './OrderDetailsModal'

function Order({ order }) {
    const orderUrl = order.order_url || null;
    const orderHref = orderUrl && /^https?:\/\//i.test(orderUrl) ? orderUrl : orderUrl ? `https://${orderUrl}` : null;
    const shortOrderUrl = order.short_order_url || null;
    const shortOrderHref = shortOrderUrl && /^https?:\/\//i.test(shortOrderUrl) ? shortOrderUrl : shortOrderUrl ? `https://${shortOrderUrl}` : null;

    const renderCopyableLink = (url, href) => {
        if (!url) return <NoneValue />;
        return (
            <CopyToClipBoard link={href}>
                <a href={href} target="_blank" rel="noopener noreferrer">{url}</a>
            </CopyToClipBoard>
        );
    };
    const [orderDetailsModal, setOrderDetailsModal] = useState(false);
    const orderDetailsModalToggle = () => setOrderDetailsModal(!orderDetailsModal);

    const [expandedOrderItems, setExpandedOrderItems] = useState(false);

    const toggleExpansion = () => {
        setExpandedOrderItems(!expandedOrderItems);
    };
    const [orderHistoryModal, setOrderHistoryModal] = useState(false);
    const orderHistoryModaltoggle = () => setOrderHistoryModal(!orderHistoryModal);
    const visibleOrderItems = expandedOrderItems ? order.order_items : order.order_items.slice(0, 4);

    return (
        <>
            <tr>
                <td onClick={orderDetailsModalToggle}>
                    <Link to="#" className="text-primary">{order.order_number}</Link>
                    {order.token_number != null && (
                        <span className="badge badge-secondary ml-1">Token {order.token_number}</span>
                    )}
                </td>
                <td>
                    <Avatar size={35} name={order.customer.email} round />
                </td>
                <td className="text-muted font-13">{order.total_amount}</td>
                <td>{order.order_source === null ? <NoneValue/> : order.order_source}</td>
                <td className="text-muted font-13">
                    {renderCopyableLink(shortOrderUrl, shortOrderHref)}
                </td>
                <td>
                    <Badge
                        badge={
                            order.order_status === "COMPLETE" ? "badge badge-light-success" :
                                order.order_status === "PENDING" ? "badge bg-soft-dark text-dark" :
                                    order.order_status === "IN-TRANSIT" ? "badge bg-soft-warning text-warning" :
                                        order.order_status === "BEING-PROCESSED" ? "badge bg-soft-info text-info" :
                                            order.order_status === "CANCELLED" ? "badge badge-light-danger" :
                                                "badge badge-light-default"
                        }
                        status={order.order_status}
                    />
                </td>
                <td>{order.payment_method === null ? <NoneValue/> : order.payment_method}</td>
                <td>
                    {/*<Badge*/}
                    {/*    badge={order.payment_status === "PAID" ? "badge badge-light-success" : order.payment_status === "REFUNDED" ? "badge badge-light-secondary": "badge badge-light-danger"}*/}
                    {/*    status={order.payment_status}*/}
                    {/*/>*/}
                    <Badge
                        badge={
                            order.payment_status === "PAID"
                                ? "badge badge-light-success"
                                : order.payment_status === "UNPAID"
                                    ? "badge badge-light-warning"
                                    : order.payment_status === "CANCELLED"
                                        ? "badge badge-light-danger"
                                        : order.payment_status === "REFUND-ISSUED"
                                            ? "badge badge-light-info"
                                            : order.payment_status === "WAIVED-OFF"
                                                ? "badge badge-light-primary"
                                                : "badge badge-light-secondary"
                        }
                        status={order.payment_status}
                    />
                </td>
                <td>{new Date(order.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                    <ActionButton order={order} />
            </tr>

            <Modal className="modal-xl" isOpen={orderDetailsModal} toggle={orderDetailsModalToggle}>
                <ModalHeader toggle={orderDetailsModalToggle} close={
                    <button className="close" onClick={orderDetailsModalToggle}>
                        &times;
                    </button>
                }>Order details</ModalHeader>
                <ModalBody>
                    <div className="card-box">
                        {order.qr_code_url? (
                            <img className="mb-2" src={order.qr_code_url} alt="order.qr_code_url" style={{ width: '150px', height: '150px' }}/>
                        ) : (
                            <>
                                <h4 className="header-title">{order.id}</h4>
                                <p className="sub-header">
                                    <Avatar size={95} name={order.customer.email} round />
                                </p>
                            </>
                        )}
                        {/*<h4 className="header-title">{order.id}</h4>*/}
                        {/*<p className="sub-header">*/}
                        {/*    <Avatar size={95} name={order.customer.email} round />*/}
                        {/*</p>*/}
                        {/*<img className="mb-2" src={order.qr_code_url} alt="order.qr_code_url" style={{ width: '150px', height: '150px' }}/>*/}

                        <div className="table-responsive">
                            <table className="table mb-0">
                                <tbody>
                                <tr>
                                    <th scope="row">Order ID</th>
                                    <td>{order.id}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Order Number</th>
                                    <td>{order.order_number}</td>
                                </tr>
                                {order.token_number != null && (
                                    <tr>
                                        <th scope="row">Token Number</th>
                                        <td>{order.token_number} ({order.token_date})</td>
                                    </tr>
                                )}
                                <tr>
                                    <th scope="row">Customer</th>
                                    <td>{order.customer.email}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Order Source</th>
                                    <td>{order.order_source === null ? <NoneValue/> : order.order_source}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Order URL</th>
                                    <td>{renderCopyableLink(orderUrl, orderHref)}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Short Order URL</th>
                                    <td>{renderCopyableLink(shortOrderUrl, shortOrderHref)}</td>
                                </tr>
                                <tr>
                                    <th scope="row"> Order Items</th>
                                    <td>
                                        <div className="mb-2">
                                            <span className="badge badge-light-primary">{order.order_items.length} items</span>
                                        </div>
                                        <div style={{display: 'flex', flexDirection: 'column', gap: "8px"}}>
                                            {visibleOrderItems.map((item, index) => (
                                                <div key={item.id || index}>
                                                    <div title={item.name} style={{display: 'flex', alignItems: 'center', gap: "8px"}}>
                                                        <span style={{minWidth: '24px'}}>{index + 1}.</span>
                                                        {item.item_image ? (
                                                            <img src={item.item_image} className="avatar-sm img-thumbnail rounded-circle" alt={item.name} />
                                                        ) : (
                                                            <Avatar size={35} name={item.name} round/>
                                                        )}
                                                        <span>{item.name}</span>
                                                        <span className="badge badge-light-secondary">{item.type}</span>
                                                    </div>
                                                    {item.type === "PRODUCT-GROUP" && item.included_products?.length > 0 && (
                                                        <div className="ml-4 mt-1" style={{display: 'flex', flexDirection: 'column', gap: "6px"}}>
                                                            <small className="text-muted">Included Products</small>
                                                            {item.included_products.map((product) => (
                                                                <div key={product.id} title={product.name} style={{display: 'flex', alignItems: 'center', gap: "8px"}}>
                                                                    {product.image ? (
                                                                        <img src={product.image} className="avatar-xs img-thumbnail rounded-circle" alt={product.name} />
                                                                    ) : (
                                                                        <Avatar size={28} name={product.name} round/>
                                                                    )}
                                                                    <span>{product.name}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                            {order.order_items.length > 4 && (
                                                <span onClick={toggleExpansion} style={{cursor: 'pointer'}}>
                                                    <div
                                                        style={{
                                                            width: '35px',
                                                            height: '35px',
                                                            backgroundColor: 'grey',
                                                            borderRadius: '50%',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            color: 'white',
                                                            fontSize: '12px',
                                                        }}
                                                    >
                                                        {!expandedOrderItems ? `+${order.order_items.length - 4}` : "-"}
                                                    </div>
                                                </span>
                                            )}
                                        </div>
                                            {/*<Button onClick={orderHistoryModaltoggle}*/}
                                            {/*    color="#4d5bed"*/}
                                            {/*    className='bx-btn-primary ml-2'*/}
                                            {/*>*/}
                                            {/*    View Order Items*/}
                                            {/*</Button>*/}
                                    </td>
                                </tr>
                                {order.reference_order_id && (
                                    <tr>
                                        <th scope="row">Reference Order ID</th>
                                        <td>
                                            <CopyToClipBoard link={order.reference_order_id}>
                                                <span style={{ fontFamily: 'monospace', fontSize: 13 }}>
                                                    {order.reference_order_id}
                                                </span>
                                            </CopyToClipBoard>
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <th scope="row">Order Sub Total(before discount)</th>
                                    <td>INR {order.sub_total_before_discount}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Order Discount</th>
                                    <td>INR {order.order_discount}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Order Sub Total(after discount)</th>
                                    <td>INR {order.sub_total_after_discount}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Tax Percentage(effective)</th>
                                    <td>{order.effective_tax_percentage} %</td>
                                </tr>
                                <tr>
                                    <th scope="row">cgst</th>
                                    {/*<td>INR {order.cgst}</td>*/}
                                    <td>{order.cgst ? `INR ${order.cgst}`: <NoneValue/>}</td>
                                </tr>
                                <tr>
                                    <th scope="row">sgst</th>
                                    {/*<td>INR {order.sgst}</td>*/}
                                    <td>{order.sgst ? `INR ${order.sgst}`: <NoneValue/>}</td>
                                </tr>
                                <tr>
                                    <th scope="row">igst</th>
                                    {/*<td>INR {order.igst}</td>*/}
                                    <td>{order.igst ? `INR ${order.igst}`: <NoneValue/>}</td>
                                </tr>
                                <tr>
                                    <th scope="row">utgst</th>
                                    <td>{order.utgst ? `INR ${order.utgst}`: <NoneValue/>}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Order Total Tax Amount</th>
                                    <td>INR {order.total_tax_amount}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Order Total</th>
                                    <td>INR {order.total_amount}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Order Status</th>
                                    <td>
                                        <Badge
                                            badge={
                                                order.order_status === "COMPLETE" ? "badge badge-light-success" :
                                                    order.order_status === "PENDING" ? "badge bg-soft-dark text-dark" :
                                                        order.order_status === "IN-TRANSIT" ? "badge bg-soft-warning text-warning" :
                                                            order.order_status === "BEING-PROCESSED" ? "badge bg-soft-info text-info" :
                                                                order.order_status === "CANCELLED" ? "badge badge-light-danger" :
                                                                    "badge badge-light-default"
                                            }
                                            status={order.order_status}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">Order Cancellation Reason</th>
                                    <td>{order.order_cancellation_reason ? order.order_cancellation_reason : <NoneValue/>}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Payment Method</th>
                                    <td>
                                        {order.payment_method ? (
                                            <Badge
                                                badge={order.payment_method === "UPI" ? "badge badge-light-success" : "badge badge-light-secondary"}
                                                status={order.payment_method}
                                            />
                                        ) : (
                                            <NoneValue />
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">Payment Status</th>
                                    <td>
                                        {/*<Badge*/}
                                        {/*    badge={order.payment_status === "PAID" ? "badge badge-light-success" : "badge badge-light-danger"}*/}
                                        {/*    status={order.payment_status}*/}
                                        {/*/>*/}
                                        {/*<Badge*/}
                                        {/*    badge={order.payment_status === "PAID" ? "badge badge-light-success" : order.payment_status === "REFUNDED" ? "badge badge-light-secondary": "badge badge-light-warning"}*/}
                                        {/*    status={order.payment_status}*/}
                                        {/*/>*/}
                                        <Badge
                                            badge={
                                                order.payment_status === "PAID"
                                                    ? "badge badge-light-success"
                                                    : order.payment_status === "UNPAID"
                                                        ? "badge badge-light-warning"
                                                        : order.payment_status === "CANCELLED"
                                                            ? "badge badge-light-danger"
                                                            : order.payment_status === "WAIVED-OFF"
                                                                ? "badge badge-light-primary"
                                                                : "badge badge-light-secondary"
                                            }
                                            status={order.payment_status}
                                        />

                                    </td>
                                </tr>
                                {order.shipping_label && (
                                    <>
                                        <tr>
                                            <th scope="row">Shipping Address</th>
                                            <td>
                                                <strong>{order.shipping_label}</strong>
                                            </td>
                                        </tr>

                                        <tr>
                                            <th scope="row">Shipping Location</th>
                                            <td>
                                                {order.shipping_address_line1}
                                                {order.shipping_address_line2 && `, ${order.shipping_address_line2}`}
                                                {order.shipping_address_line3 && `, ${order.shipping_address_line3}`}
                                                <br />
                                                {order.shipping_city}
                                                {order.shipping_state && `, ${order.shipping_state}`}
                                                {order.shipping_pincode && ` - ${order.shipping_pincode}`}
                                            </td>
                                        </tr>

                                        {order.shipping_phone_number && (
                                            <tr>
                                                <th scope="row">Shipping Phone</th>
                                                <td>{order.shipping_phone_number}</td>
                                            </tr>
                                        )}
                                    </>
                                )}

                                <tr>
                                    <th scope="row">Created</th>
                                    <td>{new Date(order.created).toLocaleString([], DateTimeOptionsMediumShort)}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Updated</th>
                                    <td>{order.updated ? new Date(order.updated).toLocaleString([], DateTimeOptionsMediumShort) : '-'}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <OrderDetailsModal order={order} modal={orderHistoryModal} modalToggle={orderHistoryModaltoggle}/>
        </>
    );
}

export default Order;
